const testIds = {
  root: 'aside-root',
  seeButton: 'aside-see-button',
  descriptionSeeButton: 'aside-description-see-button',
  editButton: 'aside-edit-button',
  categoryButton: 'aside-category-button',
  title: 'aside-title',
  templateDisplayName: 'aside-template-display-name',
  relevantCategoryButtonsTitle: 'aside-relevant-category-buttons-title',
  mobileEditAndShareButtons: 'mobile-edit-and-share',
};

export default testIds;
